import { ClaimToolAssociatedImagePayload } from "./claim-tool-associated-image";
import { AssociatedTextPhrase, ReferencePhrase } from "./common";
import { DocPhraseMergeAndReorder } from "./doc-phrase-merge-and-reorder.model";
import { SplitPhrase } from "./split-phrase.model";

export class ClaimToolElementSaveChangesData {

    phrasesOrder: DocPhraseMergeAndReorder[] = [];
    associatedText: AssociatedTextPhrase[] = [];
    associatedImages: ClaimToolAssociatedImagePayload[] = [];
    deletedReferences: ReferencePhrase[] = [];
    references: ReferencePhrase[] = [];
    deletedAssociatedText: AssociatedTextPhrase[] = [];
    deletedAssociatedImages: ClaimToolAssociatedImagePayload[] = [];
    mergedPhrases: DocPhraseMergeAndReorder[] = [];
    contentType: string;
    splitPhrases: SplitPhrase[] = [];
    phraseTypeCode: string;
    phraseSubTypeCode: string;
    phraseTypeCodeDescr: string;
    phraseSubTypeCodeDescr: string;

}